import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {PipesModule} from 'app/shared/pipes/pipes.module';
import {Angulartics2Module} from 'angulartics2';
import {SharedModule} from 'app/shared/shared.module';

import {EmployeeComponent} from './employee.component';
import {PeopleDirectoryComponent} from './people-directory/people-directory.component';
import {OrgChartComponent} from './org-chart/org-chart.component';
import {PaginationModule} from '@app/shared/pagination/pagination.module';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {TranslateModule} from '@ngx-translate/core';

const components = [
  EmployeeComponent,
  PeopleDirectoryComponent,
  OrgChartComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PipesModule,
    Angulartics2Module,
    SharedModule,
    PaginationModule,
    ScrollingModule,
    TranslateModule
  ],
  declarations: components,
  exports: components
})
export class EmployeeComponentsModule { }
